<template>
    <div :class="map !== undefined || map === false ? '' : 'view'">
        <div class="d-md-flex justify-content-md-between">
            <Breadcrumb :breadcrumb="breadcrumb"/>
            <div class="navigation duties" v-if="single_object.next || single_object.previous">
                <a class="navigation__item modal__buttons__item" :href="previous() ? `${child_href}${previous()}`: '#'" :class="{'disabled button__disabled' : !previous()}" :disabled="!previous()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.702" height="21.184" viewBox="0 0 11.702 21.184">
                        <g id="left-arrow" transform="translate(0.313 0.312)">
                            <g id="Grupo_6167" data-name="Grupo 6167" transform="translate(0 0)">
                            <path id="Trazado_3202" data-name="Trazado 3202" d="M104.207,10.275l8.935,8.934a.791.791,0,0,1-1.119,1.119l-9.494-9.493a.791.791,0,0,1,0-1.119L112.023.223a.791.791,0,0,1,1.119,1.119Z" transform="translate(-102.298 -0.001)" stroke="#fff" stroke-width="0.5"/>
                            </g>
                        </g>
                    </svg>
                    Previous
                </a>
                <a class="navigation__item modal__buttons__item ml-2" :href="next() ? `${child_href}${next()}`: '#'" :class="{'disabled button__disabled' : !next()}" :disabled="!next()">
                    Next
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.702" height="21.184" viewBox="0 0 11.702 21.184">
                        <g id="left-arrow" transform="translate(0.313 0.312)">
                            <g id="Grupo_6167" data-name="Grupo 6167" transform="translate(0 0)">
                            <path id="Trazado_3202" data-name="Trazado 3202" d="M104.207,10.275l8.935,8.934a.791.791,0,0,1-1.119,1.119l-9.494-9.493a.791.791,0,0,1,0-1.119L112.023.223a.791.791,0,0,1,1.119,1.119Z" transform="translate(-102.298 -0.001)" stroke="#fff" stroke-width="0.5"/>
                            </g>
                        </g>
                    </svg>
                </a>
            </div>
            <NextPreviousButtons
                v-if="show_next_previous_buttons"
                :id="single_object.id"
                :label_key="label_key"
                :label_key_id="label_key_id"
                :next="next"
                :previous="previous"
                :items="items"
                :child_href="'/associates-detail'"
            />
        </div>
        <h1 class="view__title title--1">
            <span v-html="title_page"/>
            <span v-if="historiable" style="margin-left:5px;">
                <img src="/assets/img/svg/history.svg" class="iconHistory" alt="History" @click="history(single_object.id, single_object.name || single_object.description)" style="margin-top:-5px;">
            </span>
        </h1>
        <h6 class="view__title title--1" style="font-size: 13px; font-weight: initial; color: gray; margin-top: -10px;" v-if="default_description !== undefined && !default_description">
            <span>
                <img src="/assets/img/svg/information.svg" style="width:15px;" alt="CustomDescription">
            </span>
            <span v-html="comment_under_title" style="margin-left:5px;"/>
        </h6>

        <div class="col-md-12 p-0" v-if="!not_include_notes">
            <span class="button__modal text-right">
                <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                    <i class="prefix ml-1">
                        <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                    </i>
                </a>
            </span>
        </div>

        <div class="detail__content">
            <div class="row mb-0">
                <div class="col-12 col-md-8 py-0">
                    <slot name="above-form-component"></slot>
                    <form class="detail__content__formdynamic" @submit.prevent="live_edition()">
                        <FormDynamic
                            :form_format="form_format"
                            :form_data="single_object"
                            :array_options="array_options"
                            :for_update="true"
                            class="pt-0"
                        /> 
                        <div v-show="unalterable === undefined || unalterable === true" class="text-center text-md-right modal__buttons">
                            <a :href="back_href" class="modal__buttons__item cancel" v-html="'Back'" style="margin-right:10px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10.121" height="6.121" viewBox="0 0 10.121 6.121">
                                    <g id="down" transform="translate(1.061 1.061)">
                                        <line id="Línea_794" data-name="Línea 794" class="cls-1" x1="4" y1="4"/>
                                        <line id="Línea_795" data-name="Línea 795" class="cls-1" y1="4" x2="4" transform="translate(4)"/>
                                    </g>
                                </svg>
                            </a>
                            <button ref="submitButton" class="btn-small-for-views mx-md-0 modal__buttons__item" v-html="'Save changes'"/>
                        </div>   
                    </form>
                </div>
                <div class="col-12 col-md-4 py-0">
                    <div class="row mb-0 no-gutters">
                        <div class="row mb-0 no-gutters detail__content__notes">
                            <div v-for="(note, i) in notes" :key="i" class="col-12 p-0 card cardModule hoverable">
                                <div class="card-content">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <a href="#" @click="modal_update(i)" class="textTitleCard" v-html="`${note.title} / ${note.creation_date}`"/>
                                            </div>
                                            <div class="col-2 text-right">
                                                <a href="#" @click="modal_deletion(i)">
                                                    <i class="material-icons prefix ">
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="mt-3 card-content__text" v-html="note.content"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div v-if="unalterable === undefined || unalterable === true" class="text-center text-md-right modal__buttons">
            <a :href="back_href" class="modal__buttons__item cancel" v-html="'Back'">
                <svg xmlns="http://www.w3.org/2000/svg" width="10.121" height="6.121" viewBox="0 0 10.121 6.121">
                    <g id="down" transform="translate(1.061 1.061)">
                        <line id="Línea_794" data-name="Línea 794" class="cls-1" x1="4" y1="4"/>
                        <line id="Línea_795" data-name="Línea 795" class="cls-1" y1="4" x2="4" transform="translate(4)"/>
                    </g>
                </svg>
            </a>
            <a class="mx-md-0 modal__buttons__item" @click="live_edition()" v-html="'Save changes'"/>
        </div> -->

        <FormModal
            :title="'New Note'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_note"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal
            :title="'Note Update'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_note"
            :array_options="array_options"
            :global_index="global_index"
            :single_object="single_note"
            @spliceObject="splice_object($event)"
        />

        <DeletionModal 
            :single_object="single_note" 
            :global_index="global_index" 
            @objectDeletion="deletion_filter($event)"
        />

        <WaitingModal/>

        <HistoryModal
            v-if="historiable"
            :histories="histories"
            :title="history_title"
            :breadcrumb="breadcrumb"
        />

    </div>
</template>

<script>

import Breadcrumb       from  '@/components/BreadcrumbComponent/Breadcrumb.vue'
import WaitingModal     from  '@/components/WaitingModal.vue'
import FormDynamic      from  '@/components/FormDynamic.vue'
import NextPreviousButtons      from  '@/components/NextPreviousButtons.vue'
import DeletionModal    from  '@/components/DeletionModal'
import FormModal        from  './FormModal'
import UpdateModal      from  './UpdateModal'
import HistoryModal     from  '@/components/HistoryModal'
import { Notyf }        from  'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import 'vuetify/dist/vuetify.min.css'
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name:   'DetailComponent',

    props: [
        'breadcrumb',
        'title_page',
        'parent_id',
        'rest_api',
        'rest_api_lite',
        'child_href',
        'rest_api_note',
        'single_object',
        'array_options',
        'form_format',
        'notes',
        'back_href',
        'map',
        'default_description',
        'comment_under_title',
        'unalterable',
        'historiable',
        'not_include_notes',
        'label_key',
        'label_key_id',
        'items',
        'next',
        'previous',
        'show_next_previous_buttons'
    ],

    components: {
        Breadcrumb,
        WaitingModal,
        FormDynamic,
        DeletionModal,
        FormModal,
        UpdateModal,
        HistoryModal,
        NextPreviousButtons
    },
    
    data() {
        return {
            notyf,
            add_btn:        'Add note',
            global_index:   null,
            single_note:    {},
            histories:      [],
            history_title:  '',
        }
    },

    methods: {

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_update(index)
        {
            this.global_index = index
            this.single_note  = this.notes[index]
            window.$('#static-update').modal('show')
        },

        unshift_object(new_object)
        {
            this.notes.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.notes.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        modal_deletion(index)
        {
            this.global_index = index
            this.single_note  = this.notes[index]
            window.$('#static-deletion').modal('show')
        },

        deletion_filter(object)
        {
            let object_destroyed = {
                id:        object.id,
                index:     object.index,
                parent_id: this.parent_id,
            }
            this.json_destroyed(this.rest_api_note, object_destroyed)
        },

        trashing(index)
        {
            this.global_index = ''
            this.single_note  = {}
            this.notes.splice(index, 1)
        },

        async live_edition(outside = false)
        {
            if(outside)
            {
                this.$refs.submitButton.click()
                return true
            }

            let response = await this.queryGetByMethod(this.rest_api, this.single_object)

            if(response.status)
            {
                this.$emit('elementsGetter', response.data)
                this.$emit('saveOutside', true)
                notyf.success('Success')
                return true
            }
            else
            {
                this.error_handling(response)
                return false
            }
        },

        async history(id, title)
        {
            if(title === undefined)
            {
                title = id.title
                id = id.id
            }
            const http_request = {
                id,
                history_request: true,
            }
            this.loader(true)
            const response = await this.get(`${this.rest_api_lite}/${JSON.stringify(http_request)}`)
            this.loader()
            if(response.status)
            {
                this.history_title = title
                this.histories = response.data.histories
                if(this.histories.length === 0)
                {
                    return this.notyf.error('Empty History')
                }
                setTimeout(()=>{
                    window.$('#static-history').modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
            }  
        },

        get_rooms()
        {
            return JSON.parse(localStorage.getItem('rooms'))
        },

        // next()
        // {
        //     const rooms = this.get_rooms()
        //     if(rooms)
        //     {
        //         const index = rooms.findIndex(item => item === this.parent_id)
        //         return index > -1 ? rooms[index + 1] : null
        //     }
        //     else
        //     {
        //         return this.single_object.next
        //     }
        // },

        // previous()
        // {
        //     const rooms = this.get_rooms()
        //     if(rooms)
        //     {
        //         const index = rooms.findIndex(item => item === this.parent_id)
        //         return index > -1 ? rooms[index - 1] : null
        //     }
        //     else
        //     {
        //         return this.single_object.previous
        //     }
        // },

    },
}
</script>